import { JhTabs, JhTabsList, JhTabsTrigger } from "designPackages/tabsPackage";
import { JhText } from "designPackages/textPackage";
import { useIsMobile } from "hooks/useDeviceType";

interface Tab {
  value: string;
  label: string;
  count: number;
}

interface TransactionHistoryV2TabsProps {
  tabs: Tab[];
  currentTab: string;
  onTabChange: (tabId: string) => void;
  holdCredits?: number;
}

const TransactionHistoryV2Tabs = ({
  tabs,
  currentTab,
  onTabChange,
  holdCredits = 0
}: TransactionHistoryV2TabsProps) => {
  const isMobile = useIsMobile();

  const getTabLabel = (tab: Tab) => {
    return tab.label;
  };

  const getTabColor = (tabId: string) => {
    // Disable Reserved Credits tab if no hold credits
    if (tabId === "CREDITS_ON_HOLD" && holdCredits === 0) {
      return "muted-foreground";
    }
    return tabId === currentTab ? "foreground" : "muted-foreground";
  };

  const isTabDisabled = (tabId: string) => {
    return tabId === "CREDITS_ON_HOLD" && holdCredits === 0;
  };

  return (
    <div
      id="th-v2-tabs-wrapper"
      className="bg-slate-100 rounded-lg p-1 w-full md:w-fit"
    >
      <JhTabs value={currentTab} className="tw-root">
        <JhTabsList className="bg-transparent h-auto p-0 gap-2 w-full">
          {tabs.map(tab => (
            <JhTabsTrigger
              key={tab.value}
              value={tab.value}
              onClick={() => !isTabDisabled(tab.value) && onTabChange(tab.value)}
              className={`flex-1 ${isTabDisabled(tab.value) ? "cursor-not-allowed opacity-50" : ""
                }`}
              disabled={isTabDisabled(tab.value)}
            >
              <JhText variant="body2" color={getTabColor(tab.value)}>
                {getTabLabel(tab)}
              </JhText>
            </JhTabsTrigger>
          ))}
        </JhTabsList>
      </JhTabs>
    </div>
  );
};

export default TransactionHistoryV2Tabs;
